

// @ts-nocheck

    /*

    HOW TO ENABLE SHOW IF SKIP:

    bottom of checkboxes:
        <Checkbox class="mt-6" v-if="!childComp && $store.getters['survey/stepField']([...baseFieldAddress, 'allowSkip'])" @update="changeShowTestimonial" :customModelInitValue="showTestimonialWhenSkipped" label="Testimonial" text="Ask for a testimonial when skipped" textTip="The question below will only be asked if this review/share question is skipped, and the respondent does not leave a review/share."/>                
    
    second to bottom of templates:
        <template v-slot:bottomcntnt>
            <p v-if="showTestimonialWhenSkipped && open && $store.getters['survey/stepField']([compIndex, 'allowSkip'])" class="block text-center w-full my-10">IF SKIPPED<InlineTooltipQuestion text="The testimonial question will only be asked if the respondent does not select on a review/share option."/></p>
            <Testimonial :key="String('childTest'+compIndex)" v-if="!childComp && showTestimonialWhenSkipped && open && $store.getters['survey/stepField']([...baseFieldAddress, 'allowSkip'])" :compIndex="compIndex" :childComp="true" class="w-full pb-5 px-5" />                
        </template>
    
    */

    import RatingScaleSelector from './common/RatingScaleSelector.vue'
    import StepContainer from './common/StepContainer.vue'
    import Vue from 'vue'
    import RepeatingStepLogic from './common/RepeatingStepLogic'  
    import ContentDisplayClosed from './common/ContentDisplayClosed.vue'
    import HelperMethods from './common/HelperMethods'
    import ShareReviewOrderSelector from './common/ShareReviewOrderSelector.vue'
    import TextInputButton from './common/TextInputButton.vue'
    import TextAreaButton from './common/TextAreaButton.vue'
    import Checkbox from './common/Checkbox.vue'
    import TipsSelector from './common/TipsSelector.vue'
    import ActiveSharesReviews from './common/ActiveSharesReviews.vue'
    import { createStep } from 'fblshared'
    import InlineTooltipQuestion from './common/InlineTooltipQuestion.vue'

    export default Vue.extend({
        //--------
        name: 'ShareQ',
        data () {
            return {
                showTestimonialWhenSkipped: false,
                testimonialQuestionWhenCreated: false
            }
        },
        //-------
        mixins: [RepeatingStepLogic, HelperMethods],
        //--------
        created (): void {    
            const showIfSkip = this.$store.getters['survey/stepField']([...this.baseFieldAddress, 'showIfSkip'])
            if (showIfSkip) {
                //Reviews/share question needs to be rendered
                this.showTestimonialWhenSkipped = true
                //record what the share question looked like:
                this.testimonialQuestionWhenCreated = showIfSkip
            } else {
                this.showTestimonialWhenSkipped = false
            }      
        },
        //---------
        props: {
            compIndex: Number            
        },
        //--------
        components: {
            RatingScaleSelector,
            surveystep: StepContainer,
            ContentDisplayClosed,
            ShareReviewOrderSelector,
            TextInputButton,
            TextAreaButton,
            Checkbox,
            TipsSelector,
            ActiveSharesReviews,
            Testimonial: () => import('./Testimonial.vue'), //Webpack async import, to prevent circular references! Because Testimonial comp needs ShareQ, which needs Testimonial Comp and so on....
            InlineTooltipQuestion
        },
        //--------
        computed: {
            activeActions(): any[] {
                return this.$store.getters['survey/stepField']([...this.baseFieldAddress,'shareActions'])
            },
            baseFieldAddress(): any[] {
                //because this question may be a 'child' question contained in the "showIfSkip" field, 
                //the base address of fields in this question should change.
                if (this.childComp) {
                    return [this.compIndex, 'showIfSkip']
                } else {
                    return [this.compIndex]
                }                
            } 
        },        
        //--------
        methods: {
            changeShowTestimonial(v: boolean): void {                
                
                if (v) {
                    
                    //we need to show a share question. Was there one when loaded?
                    if (this.testimonialQuestionWhenCreated) {
      
                        this.$store.commit('survey/CHANGE_FIELD', {
                        // @ts-ignore
                            fieldAddress: [...this.baseFieldAddress, 'showIfSkip'],
                            val: this.testimonialQuestionWhenCreated
                        })

                    } else {

                        this.$store.commit('survey/CHANGE_FIELD', {
                        // @ts-ignore
                            fieldAddress: [...this.baseFieldAddress, 'showIfSkip'],
                            val: createStep('testimonial', this.$store.getters['dash/currentLanguagePackName'].substring(0,2), this.$store.state.survey.surveySetup.ratingType)
                        })

                    } 

                } else {
                    this.$store.commit('survey/CHANGE_FIELD', {
                        // @ts-ignore
                            fieldAddress: [...this.baseFieldAddress, 'showIfSkip'],
                            val: false
                        })
                }
                
                this.showTestimonialWhenSkipped = v

            }
        }
    })
